const adminShortcutsStyle = () => ({
	paperStyle: {
		'margin-left': '15px',
		'margin-right': '5px',
		borderRadius: 8,
		cursor: 'pointer',
		'box-shadow':
			'0px 7px 8px 0px rgba(0,0,0,0.05),0px 5px 22px 4px rgba(0,0,0,0.04),0px 12px 17px 2px rgba(0,0,0,0.04)',
	},
	iconContainer: {
		margin: '16px auto 16px 16px',
		textAlign: 'left',
		'& svg': {
			height: 40,
			width: 40,
			color: '#595959',
		},
	},
	textWrapper: {
		margin: '0 16px 16px',
		'max-width': '128px',
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
		display: '-webkit-box',
		'-webkit-line-clamp': 4,
		'-webkit-box-orient': 'vertical',
	},
});

export default adminShortcutsStyle;
